import { io } from 'socket.io-client';

// In production, frontend & backend are served from the same origin.
// In development, the backend runs on port 3001.
const getSocketURL = () => {
  if (import.meta.env.VITE_BACKEND_URL) {
    return import.meta.env.VITE_BACKEND_URL;
  }
  if (typeof window !== 'undefined') {
    // In local development, the backend always runs on port 3001
    if (import.meta.env.DEV) {
      return `${window.location.protocol}//${window.location.hostname}:3001`;
    }
    return window.location.origin;
  }
  return 'http://localhost:3001';
};

const URL = getSocketURL();

export const socket = io(URL, {
  autoConnect: false // Connect manually when needed
});
